import { createContext, useReducer, useEffect } from "react";
import { authReducer } from "./BCPAuthReducers";
import AuthObject from "./objects/BCPAuthObject";
import { globalVariables } from "../../global/GlobalVariables";
import { postData } from "../utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const authObject = new AuthObject();

  const [authState, dispatch] = useReducer(
    authReducer,
    authObject.initialToken()
  );

  useEffect(() => {
    dispatch({
      type: "initialise",
      payload: authObject
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      authState?.accessTokenString !== authObject?.accessTokenString ||
      authState?.idTokenString !== authObject?.idTokenString ||
      authState?.refreshTokenString !== authObject?.refreshTokenString
    ) {
      authObject.syncTokens(authState);
    }
    // eslint-disable-next-line
  }, [authState]);

  return (
    <AuthContext.Provider value={{ authState, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export async function currentAuthSession(options) {
  const authObject = new AuthObject();
  const globalVars = globalVariables();
  authObject.initialToken();
  if (!options?.ignoreExpired) {
    if (authObject?.idTokenExpired || authObject?.accessTokenExpired) {
      if (
        authObject?.refreshTokenString &&
        authObject?.refreshTokenString !== "undefined"
      ) {
        try {
          const customUrl = getEnvironmentVariable("API");

          const apiRequest = await postData(
            "/oauth/token",
            {
              body: {
                refresh_token: authObject.refreshTokenString,
                grant_type: "refresh_token"
              }
            },
            "APIUnsecured",
            { "client-id": globalVars?.amplify?.userPoolWebClientId },
            customUrl
          );
          authObject.syncTokens({
            accessTokenString: apiRequest?.accessToken,
            idTokenString: apiRequest?.idToken,
            refreshTokenString: apiRequest?.refreshToken
          });
        } catch (err) {
          authObject.removeTokens();
        }
      } else {
        authObject.removeTokens();
      }
    }
  }
  return authObject;
}
